import { render, staticRenderFns } from "./PaymentMethodBadge.vue?vue&type=template&id=f57c39b8"
import script from "./PaymentMethodBadge.vue?vue&type=script&lang=js"
export * from "./PaymentMethodBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports